import { useQuery } from "@tanstack/react-query";
import { INTERNAL_KEYS } from "./queryKeys";
import { getRebuildAPI } from "@rebuild/shared/api";

const { organizationsControllerGetNames } = getRebuildAPI();

export function useGetAllOrganizationsQuery(isInternal: boolean) {
  return useQuery({
    queryKey: INTERNAL_KEYS.organizations(),
    queryFn: async () => {
      const { data } = await organizationsControllerGetNames();
      return data;
    },
    enabled: isInternal,
  });
}
